const state = {
    pagination: {
        from: 1,
        to: 9,
        currentPage: 1,
        lastPage: 0,
        perPage: 10,
        total: 0,
    },
};

const mutations = {
    set_pagination(state, payload) {
        state.pagination = {
            from: payload.from,
            to: payload.to,
            currentPage: payload.current_page,
            lastPage: payload.last_page,
            perPage: payload.per_page,
            total: payload.total,
        };
    },

    reset_pagination(state) {
        Object.assign(state.pagination, {
            from: 1,
                to: 9,
                currentPage: 1,
                lastPage: 0,
                perPage: 10,
                total: 0,
        });
    },
};

const actions = {
    resetPagination({commit}) {
        commit('reset_pagination');
    },
};

const getters = {
    pagination: state => state.pagination,
};

/** export **/
export default {state, actions, mutations, getters};
